/**
 * Como se leen las solicitudes en Gestion Biblioteca: el color de cada estado
 * y las columnas del listado. Sin React, igual que presentacion.js.
 */
import { coloresEmma } from "../../../global/js/funciones";
import { ESTADO_SOLICITADA, TIPO_ARIA, TIPO_LIBROS } from "../constants";
import { hora, momento } from "./presentacion";
import { nombreCompleto } from "./solicitud";

export const ESTADO_REVISADA = "Bib_Rev_E";
export const ESTADO_PREPARADA = "Bib_Pre_E";

// Los que marca el filtro de estados al entrar, en Gestion y en Procesos:
// las solicitudes que siguen en curso (decidido el 2026-10-14).
export const ESTADOS_POR_DEFECTO = [ESTADO_SOLICITADA, ESTADO_REVISADA, ESTADO_PREPARADA];

/** "Base - Solicitada, En revision", o solo la base si son todos. */
export const tituloConEstados = (base, estados, elegidos) => {
  const nombres = estados
    .filter(({ codigo }) => elegidos.includes(codigo))
    .map(({ nombre }) => nombre);
  return nombres.length ? `${base} - ${nombres.join(", ")}` : base;
};

/**
 * Lo que falta para preparar un Libro a tu clase, como en AGIL: al menos un
 * ejemplar y todos con estudiante. "" si no falta nada.
 */
export const ejemplaresQueFaltan = ({ ejemplares = [] }) => {
  if (ejemplares.length === 0) return "Registra al menos un ejemplar";
  const sinAsignar = ejemplares.filter(({ estudiante }) => !estudiante).length;
  return sinAsignar ? `Asigna los ${sinAsignar} ejemplares que no tienen estudiante` : "";
};

// Que auxiliares exige cada tipo para revisar, como en AGIL. Es
// ACCIONES_POR_TIPO del backend, que lo vuelve a comprobar.
const ACCIONES_PARA_REVISAR = {
  [TIPO_LIBROS]: [
    ["Acc_Ent", "entrega"],
    ["Acc_Ret", "retiro"],
  ],
  [TIPO_ARIA]: [["Acc_Cap", "capacitar"]],
};

/** Nombres de las acciones sin ningun auxiliar asignado: ["retiro"]. */
export const auxiliaresQueFaltan = (solicitud) => {
  const asignadas = (solicitud.auxiliares ?? []).map(({ accion }) => accion);
  return (ACCIONES_PARA_REVISAR[solicitud.tipo_solicitud?.codigo] ?? [])
    .filter(([codigo]) => !asignadas.includes(codigo))
    .map(([, nombre]) => nombre);
};

const BLANCO = "white";

// Los mismos colores que usa Gestion Practicas para estados equivalentes.
const COLORES = {
  Bib_Sol_E: { backgroundColor: "#EEEEEE", color: "#757575" },
  Bib_Rev_E: { backgroundColor: coloresEmma.solicitudenrevision, color: BLANCO },
  Bib_Pre_E: { backgroundColor: coloresEmma.solicitudactiva, color: BLANCO },
  Bib_Ent_E: { backgroundColor: coloresEmma.solicitudAceptada, color: BLANCO },
  Bib_Fin_E: { backgroundColor: coloresEmma.solicitudfinalizada, color: BLANCO },
  Bib_Rec_E: { backgroundColor: coloresEmma.solicitudcancelada, color: BLANCO },
  Bib_Can_E: { backgroundColor: coloresEmma.solicitudnoseleccionada, color: BLANCO },
};

/** Estilo del avatar de un estado. Uno nuevo, sin color asignado, sale gris. */
export const colorDeEstado = (codigo) => COLORES[codigo] ?? COLORES.Bib_Sol_E;

const fecha = ({ fecha_prestamo, hora_inicio, hora_fin }) =>
  [fecha_prestamo, [hora(hora_inicio), hora(hora_fin)].filter(Boolean).join(" a ")]
    .filter(Boolean)
    .join(", ");

/**
 * Columnas del listado de gestion, en el formato de ListarDatos. Las que
 * tienen `enLista: false` no se pintan, pero salen en el Excel y el buscador
 * no las tiene en cuenta.
 *
 * ListarDatos pinta `nombre` pegado al valor, por eso lleva los dos puntos;
 * el estado va sin etiqueta, como en Gestion Practicas, y en el Excel toma
 * el `id` como encabezado.
 */
/** Fila principal del listado: quien la pidio. */
export const filaPrincipalGestion = ({ solicitante }) =>
  nombreCompleto(solicitante).toUpperCase();

export const COLUMNAS_GESTION = [
  {
    // La fila principal no se exporta: se repite aqui solo para el Excel.
    id: "Solicitante",
    mostrar: filaPrincipalGestion,
    enLista: false,
  },
  {
    id: "Estado",
    mostrar: ({ estado_actual }) => estado_actual?.nombre ?? "",
  },
  {
    // La tabla mezcla los dos tipos: cada fila dice el suyo.
    id: "tipo",
    nombre: "Tipo: ",
    mostrar: ({ tipo_solicitud }) => tipo_solicitud?.nombre ?? "",
  },
  {
    id: "identificacion",
    nombre: "Identificacion: ",
    mostrar: ({ solicitante }) => solicitante?.identificacion ?? "",
  },
  {
    id: "materia",
    nombre: "Materia: ",
    mostrar: ({ materia, grupo }) =>
      materia ? [materia, grupo].filter(Boolean).join(" / ") : "",
  },
  {
    id: "fecha",
    nombre: "Fecha: ",
    mostrar: fecha,
  },
  {
    id: "registro",
    nombre: "Registrada: ",
    mostrar: ({ fecha_registro }) => momento(fecha_registro),
  },
  {
    id: "correo",
    nombre: "Correo: ",
    mostrar: ({ solicitante }) => solicitante?.correo ?? "",
    enLista: false,
  },
  {
    id: "periodo",
    nombre: "Periodo: ",
    mostrar: ({ periodo }) => periodo ?? "",
    enLista: false,
  },
];

